import { useEffect, useState } from 'react';
import { type Location, useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';

import { useScreenSize, type ScreenSize } from '@/ui/hooks/useScreenSize';
import { Col, Container, Row } from 'react-bootstrap';

import { IFooterSections } from '@/domain/interfaces/IFooterSections';

/**
 * Componente `Blog` que representa una página de blog en la aplicación.
 * 
 */
const Blog = (): JSX.Element => {

    /** Obtiene el tamaño de la pantalla y determina si el dispositivo es móvil. */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();
    const isMobile: boolean = width < maxLargeWidth;

    /** Hook para trabajar con document location  */
    const location: Location = useLocation();

    /** Establece el estado que guarda la data del Blog */
    const [blogSection] = useState<IFooterSections | null>(location.state.blogSection ?? '');


    /**Scroll al navegar */
    useEffect(() => {
        window.scroll(0, 0);
    }, [location.search]);

    return (
        <Container className={isMobile ? 'py-3 px-3' : 'py-4'}>
            <Container className="bg-primary-4 shadow">
                {blogSection && (
                    <Row className="g-0">
                        <Col className={isMobile ? 'py-5 px-1' : 'px-5 py-5'}>
                            <h1 className="text-secondary-1 text-center">{blogSection.title ?? ''}</h1>
                            <Col
                                className="text-secondary-2 text-justify p-large mt-4"
                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogSection.content ?? '') }}
                            />
                        </Col>
                    </Row>
                )}
            </Container>
        </Container>
    );
};

export default Blog;